// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Nav_Nav__vYnCO"};